import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiListeningBrandProfileApiService } from 'src/services/aiListeningApi/brandProfile'

// Shorter text has no context worth a model call.
export const MIN_PROMPT_CONTEXT_LENGTH = 8

// POST under the hood, but the answer depends on the text alone, so it is
// cached per text: typing back to an earlier wording costs no new call.
// Callers pass the debounced text.
export const useGetAiListeningPromptContextQuery = (prompt: string) => {
  const text = prompt.trim()

  return useQuery({
    enabled: text.length >= MIN_PROMPT_CONTEXT_LENGTH,
    queryFn: () => AiListeningBrandProfileApiService.detectContext(text),
    queryKey: [QueryKey.GET_AI_LISTENING_PROMPT_CONTEXT, text],
    retry: false,
    staleTime: Infinity,
  })
}
